var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirrorNavIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 41 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15133_102325",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 36
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rechteck 856",
    d: "M40.6673 0.667969H0.333984V35.9596H40.6673V0.667969Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15133_102325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe 1887"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad 770",
    d: "M30.5837 10.7513C30.5837 12.7456 29.9923 14.6951 28.8843 16.3533C27.7763 18.0115 26.2015 19.3039 24.3591 20.0671C22.5166 20.8303 20.4891 21.03 18.5332 20.6409C16.5772 20.2518 14.7805 19.2915 13.3703 17.8813C11.9602 16.4711 10.9998 14.6744 10.6107 12.7185C10.2217 10.7625 10.4214 8.73507 11.1845 6.89258C11.9477 5.05009 13.2401 3.47529 14.8983 2.36732C16.5565 1.25935 18.506 0.667969 20.5003 0.667969C23.1746 0.667969 25.7393 1.73032 27.6303 3.62131C29.5213 5.5123 30.5837 8.07704 30.5837 10.7513Z",
    fill: "#97A5A9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad 771",
    d: "M40.6673 35.9583H0.333984C0.333984 33.2841 1.39633 30.7193 3.28732 28.8283C5.17832 26.9374 7.74305 25.875 10.4173 25.875H30.584C33.2583 25.875 35.823 26.9374 37.714 28.8283C39.605 30.7193 40.6673 33.2841 40.6673 35.9583Z",
    fill: "#97A5A9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirrorNavIcon);
export default __webpack_public_path__ + "static/media/Mirror_Nav_Icon.47a56d42fbdc1ca2dc7d455de3e819b1.svg";
export { ForwardRef as ReactComponent };